var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBonfire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bonfire") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M13.69 28.026C12.564 30.599 12 33.585 12 37c0 8.837 7.163 16 16 16s16-7.163 16-16c0-2.65-1.061-5.295-4.043-7.863-1.558-1.343-2.56-2.577-3.161-3.903a7.859 7.859 0 0 1-.517-1.475c-.315 1.388-.422 3.265-.282 5.653.092 1.563-1.97 2.204-2.78.864-2.673-4.418-3.15-8.47-1.316-12.41 1.848-3.97 2.21-7.559 1.092-10.85-.717 3.747-2.933 7-6.606 9.694-4.621 3.388-7.076 8.299-7.389 14.861-.062 1.301-1.638 1.91-2.559.99-1.389-1.39-2.308-2.91-2.75-4.535zm2.85-.966c1.104-5.357 3.799-9.635 8.073-12.77 4.55-3.336 6.308-7.439 5.41-12.53C29.756.25 31.66-.64 32.648.536c4.538 5.398 5.19 11.69 1.972 18.598a8.712 8.712 0 0 0-.693 2.156c.651-1.528 1.634-2.59 2.982-3.168A1.5 1.5 0 0 1 39 19.5v.255c-.002 2.451.083 3.259.528 4.24.402.887 1.135 1.79 2.387 2.868C45.603 30.04 47 33.524 47 37c0 10.493-8.507 19-19 19S9 47.493 9 37c0-6.341 1.783-11.527 5.366-15.482a1.494 1.494 0 0 1 .778-.475 1.508 1.508 0 0 1 1.365.347 1.511 1.511 0 0 1 .448.754 1.491 1.491 0 0 1-.06.906c-.53 1.446-.651 2.771-.358 4.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56v56H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonfire);
export default __webpack_public_path__ + "static/media/bonfire.30fe6bfafc391dced988218768401e8a.svg";
export { ForwardRef as ReactComponent };